import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { dashApi } from "@/lib/dashApi";
import { fmtDateTime, fmtRelative } from "@/lib/format";
import { EmptyState, ErrorState, LoadingState, PageHeader, Panel, SourceBadge, TrustPill } from "@/components/dash/ui";

export default function ConnectorFreshnessPage() {
  const q = useQuery({ queryKey: ["trust-connectors"], queryFn: dashApi.trustConnectors });
  const [label, setLabel] = useState("all");
  const rows = (q.data?.connectors ?? []).filter((c) => label === "all" || c.label === label);
  const labels = ["all", ...Object.keys(q.data?.summary ?? {})];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Connector Freshness"
        description="Are Odoo, PrestaShop, RepairPanel, IronPayments, IronChat, PIM and Rota fresh and healthy? Trust label, last successful sync and the reason for any warning."
        right={
          <select value={label} onChange={(e) => setLabel(e.target.value)} className="rounded-lg border border-ink-500/60 bg-ink-800 px-2.5 py-1.5 text-xs text-slate-200 [color-scheme:dark]">
            {labels.map((l) => <option key={l} value={l}>{l === "all" ? "All trust labels" : l}</option>)}
          </select>
        }
      />
      <Panel title={`Connectors (${rows.length})`}>
        {q.isLoading ? <LoadingState /> : q.isError ? <ErrorState error={q.error} /> : !rows.length ? (
          <EmptyState>No connectors match this filter.</EmptyState>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
              <th className="pb-2 font-medium">Source</th><th className="pb-2 font-medium">Trust</th>
              <th className="pb-2 font-medium">Status</th><th className="pb-2 font-medium">Reason</th>
              <th className="pb-2 text-right font-medium">Last data</th><th className="pb-2 text-right font-medium">Last success</th>
            </tr></thead>
            <tbody className="divide-y divide-ink-500/40">
              {rows.map((c) => (
                <tr key={c.source} className="text-slate-300">
                  <td className="py-2"><SourceBadge code={c.source} /> <span className="text-slate-100">{c.name}</span></td>
                  <td className="py-2"><TrustPill label={c.label} /></td>
                  <td className="py-2 text-slate-400">{c.status}</td>
                  <td className="py-2 text-xs text-slate-400">{c.reason}</td>
                  <td className="py-2 text-right text-[11px] text-slate-500">{c.freshness ? fmtRelative(c.freshness) : "never"}</td>
                  <td className="py-2 text-right text-[11px] text-slate-500">{c.last_success ? fmtDateTime(c.last_success) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Panel>
    </div>
  );
}
